<template>
    <div class="container" id="loginContainer">
        <div class="card" v-if="!validationId">
            <h5 class="card-header">Login</h5>
            <div class="card-body">
                <b-form @submit.prevent="submitPhone">
                    <b-form-group label="Telefon Numarası İle Giriş." label-for="phone" state>
                        <b-form-input id="phone" required number type="number" v-model="phoneNumber" placeholder="905*********" trim></b-form-input>
                    </b-form-group>
                    <b-button :disabled="loading" type="submit" variant="primary">Login</b-button>
                </b-form>
            </div>
        </div>
        <div class="card" v-if="validationId">
            <h5 class="card-header">Validate</h5>
            <div class="card-body">
                <b-form @submit.prevent="login">
                    <b-form-group label="Sms Code" label-for="code" state>
                        <b-form-input id="code" required number type="number" v-model="code" placeholder="****" trim></b-form-input>
                    </b-form-group>
                    <b-button :disabled="loading" type="submit" variant="primary">Validate & Login</b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
import { BForm } from 'bootstrap-vue'
import LoginRequest from '../../store/actions/loginRequest'
import LoginValidate from '../../store/actions/loginValidate'
import showError from "../../helpers/showError";

  export default {
    name: 'Login',
    components: {
      BForm
    },
    data() {
      return {
        phoneNumber: undefined,
        validationId: undefined,
        uniqueId: undefined,
        expireAt: undefined,
        code: undefined,
        loading: false
      }
    },
    methods: {
      async login() {
        this.loading = true;
        try{
          await LoginValidate({
            validationId: this.validationId,
            code: String(this.code)
          })
          window.location.href = "/";
        }catch (e) {
          showError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async submitPhone(){
        this.loading = true;
        try{
          const result = await LoginRequest(String(this.phoneNumber));
          this.validationId = result.validationId;
          this.expireAt = result.expireAt;
          this.uniqueId = this.$store.state.uniqueId;
        }
        catch (e) {
          showError(this, e);
        }
        finally {
          this.loading = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    #loginContainer {
        max-width: 500px !important;
        margin: 15% auto;
    }
</style>
